import { API_STATUS } from 'core-lib/constants/network';
import ip from 'icepick';
import { ReducerType } from '../../types/new/store';
import { BookingStep } from '../../types/new/packages';

import {
  SET_LOCATION,
  SET_VEHICLE,
  SET_MAIN_PACKAGE_DATA,
  SET_MAIN_DEALER_LIST_DATA,
  SET_BOOKING_STEP,
  SET_KMS_DRIVEN,
  SET_OTHER_DEALER_LIST_DATA,
} from './type';
import { AddressStatusType } from 'core-lib/types/Address';

const initialState: ReducerType = ip.freeze({
  selectedLocation: {
    data: null,
    status: AddressStatusType.Default,
  },
  selectedVehicle: null,
  bookingStep: BookingStep.PackageSelection,
  kmsDriven: null,
  mainPackagesData: {
    apiStatus: API_STATUS.default,
    loading: false,
    data: null,
  },
  mainDealersList: {
    apiStatus: API_STATUS.default,
    loading: false,
    data: null,
    myCarDealer: null,
    totalCount: 0,
  },
  otherDealersList: {
    apiStatus: API_STATUS.default,
    loading: false,
    data: null,
    totalCount: 0,
  },
});

export function carServicingReducer(state = initialState, action) {
  switch (action.type) {
    case SET_LOCATION: {
      state = ip.setIn(state, ['selectedLocation'], action.payload);
      return state;
    }
    case SET_VEHICLE: {
      state = ip.setIn(state, ['selectedVehicle'], action.payload);
      return state;
    }
    case SET_BOOKING_STEP: {
      state = ip.setIn(state, ['bookingStep'], action.payload);
      return state;
    }
    case SET_MAIN_PACKAGE_DATA: {
      const { apiStatus, data, loading } = action.payload;
      state = ip.setIn(state, ['mainPackagesData', 'apiStatus'], apiStatus);
      state = ip.setIn(state, ['mainPackagesData', 'data'], data);
      state = ip.setIn(state, ['mainPackagesData', 'loading'], loading);
      return state;
    }
    case SET_MAIN_DEALER_LIST_DATA: {
      const { apiStatus, data, myCarDealer, loading, totalCount } = action.payload;
      state = ip.setIn(state, ['mainDealersList', 'apiStatus'], apiStatus);
      state = ip.setIn(state, ['mainDealersList', 'data'], data);
      state = ip.setIn(state, ['mainDealersList', 'myCarDealer'], myCarDealer);
      state = ip.setIn(state, ['mainDealersList', 'loading'], loading);
      state = ip.setIn(state, ['mainDealersList', 'totalCount'], totalCount);
      return state;
    }
    case SET_OTHER_DEALER_LIST_DATA: {
      const { apiStatus, data, loading, totalCount } = action.payload;
      state = ip.setIn(state, ['otherDealersList', 'apiStatus'], apiStatus);
      state = ip.setIn(state, ['otherDealersList', 'data'], data);
      state = ip.setIn(state, ['otherDealersList', 'totalCount'], totalCount);
      return state;
    }
    case SET_KMS_DRIVEN: {
      state = ip.setIn(state, ['kmsDriven'], action.payload);
      return state;
    }
    default:
      return state;
  }
}

export default carServicingReducer;
